module.exports = __webpack_public_path__ + "static/img/youtube_sm.35c7db1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/youtube_sm.svg
// module id = qHTH
// module chunks = 1